import { Box, Container, Grid, Typography } from "@mui/material";
import React, { useRef, useState } from "react";
import { useForm } from "react-hook-form";
import uploadImage from "../../../image/wmremove-transformed-Photorooms.jpg";
import { StyledContainer, styles } from "../../components/formStyles";
import CustomButton from "../../constant/commonButton";
import ReusableFormFields from "../../constant/reusableFormFields";
import CommonDialog from "../../notification/Dialogbox";
import CommonSnackbar from "../../notification/Snackbar";
const AddCustomer = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [fileName, setFileName] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(true);
  const [customerDetails, setCustomerDetails] = useState([]);
  const fileInputRef = useRef(null);
  const MAX_FILE_SIZE = 200 * 1024;
  const ALLOWED_FILE_TYPES = ["image/jpeg", "image/png"];
  const readFile = (file, onLoadCallback) => {
    const reader = new FileReader();
    reader.onload = () => onLoadCallback(reader.result);
    reader.readAsDataURL(file);
  };
  const {
    control,
    setValue,
    register,
    reset,
    formState: { errors },
  } = useForm();
  const inputFields = [
    {
      name: "first_name",
      label: "Name",
      rules: { required: "First Name is required" },
    },
    {
      name: "last_name",
      label: "Name",
      rules: { required: "Last Name is required" },
    },
    {
      name: "address",
      label: "Address",
      rules: { required: "Address is required" },
    },
    {
      name: "email",
      label: "Email",
      rules: { required: "Address is required" },
    },
    {
      name: "phone",
      label: "Phone No",
      rules: {
        required: "Phone No is required",
        pattern: {
          value: /^\d{10}$/,
          message: "Invalid Phone Number",
        },
      },
    },
    {
      name: "dob",
      label: "Date of Birth",
      rules: {
        required: "Date of Birth is required",
        pattern: {
          value: /^\d{4}-\d{2}-\d{2}$/,
          message: "Invalid Date of Birth. Format: YYYY-MM-DD",
        },
      },
    },
  ];
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.size > MAX_FILE_SIZE) {
        showSnackbar("Please select a file smaller than 200kB.", "error");
        return;
      }
      if (!ALLOWED_FILE_TYPES.includes(file.type)) {
        showSnackbar(
          "Invalid file type. Only JPEG and PNG are allowed.",
          "error"
        );
        return;
      }
      readFile(file, (result) => {
        const base64String = result.split(",")[1];
        setSelectedFile(base64String);
        setImagePreview(URL.createObjectURL(file));
        setFileName(file.name);
        setValue("fileName", file.name);
      });
    }
  };
  const handleImage = () => {
    if (selectedFile) {
      showSnackbar(
        `Product details saved with file: ${selectedFile.name}`,
        "success"
      );
    } else {
      showSnackbar("Please choose a file before saving.", "error");
    }
  };
  const resetFileInputs = () => {
    setSelectedFile(null);
    setImagePreview(null);
    setFileName("");
    if (fileInputRef.current) fileInputRef.current.value = "";
  };
  const handleCancel = () => {
    reset({
      name: "",
      address: "",
      email: "",
      username: "",
      resetPassword: "",
    });
    resetFileInputs();
  };
  const onSubmit = (data) => {
    const emailExists = customerDetails.some(
      (customer) => customer.email === data.email
    );
    if (emailExists) {
      showSnackbar(
        "Email already exists. Please use a different email.",
        "error"
      );
      return;
    }
    setCustomerDetails((prevList) => [...prevList, data]);
    setIsSuccess(true);
    setDialogOpen(true);
    reset({
      name: "",
      address: "",
      email: "",
      username: "",
      resetPassword: "",
    });
    resetFileInputs();
  };
  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
  const handleDialogClose = () => {
    setDialogOpen(false);
  };
  return (
    <Container>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={6} xl={5}>
          <Box>
            <Typography variant="h5" gutter Bottom sx={styles.title}>
              Add Customer Data
            </Typography>
          </Box>
          <Box>
            <StyledContainer>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={2} xl={2}>
                  <img
                    src={imagePreview || uploadImage}
                    alt="Image"
                    width={80}
                    height={80}
                    style={styles.image}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={10} xl={10}>
                  <Typography variant="p" gutterBottom sx={styles.photoContent}>
                    Please upload square image, size less than 200KB
                  </Typography>
                  <Box sx={styles.fileButtonContainer}>
                    <CustomButton
                      variant="outlined"
                      component="label"
                      size="small"
                      buttonStyle="chooseFileButton"
                    >
                      Choose File
                      <input type="file" hidden onChange={handleFileChange} />
                    </CustomButton>
                    <CustomButton
                      variant="contained"
                      size="small"
                      buttonStyle="fileNameButton"
                      selectedFile={Boolean(selectedFile)}
                    >
                      {fileName || "No File Chosen"}
                    </CustomButton>
                  </Box>
                  <Box sx={styles.saveButtonContainer}>
                    <CustomButton
                      text="Save"
                      buttonStyle="saveButton"
                      onClick={handleImage}
                      size="small"
                    >
                      Save
                    </CustomButton>
                  </Box>
                </Grid>
              </Grid>
            </StyledContainer>
          </Box>
          <Box>
            <Typography variant="body2" gutterBottom sx={styles.note}>
              <span style={{ color: "red" }}>Note:</span> Only JPEG or PNG
              format is supported <span style={{ color: "red" }}>*</span>
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={6} xl={5}></Grid>
        <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
          <ReusableFormFields
            inputFields={inputFields}
            control={control}
            errors={errors}
            register={register}
            required={false}
          />
          <Box sx={styles.submitGap}>
            <Grid container spacing={2} item xs={12}>
              <Grid item xs={6}>
                <CustomButton
                  text="Submit"
                  size="medium"
                  type="submit"
                  buttonStyle="StyledButton"
                  // disabled={addProductState.addProduct.inProgress}
                  // loading={addProductState.addProduct.inProgress}
                />
              </Grid>
              <Grid item xs={6}>
                <CustomButton
                  text="Cancel"
                  variant="contained"
                  size="medium"
                  fullWidth
                  buttonStyle="style1"
                  onClick={handleCancel}
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      {/* Snackbar */}
      <CommonSnackbar
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
      {/* Dialog */}
      <CommonDialog
        open={dialogOpen}
        isSuccess={isSuccess}
        onClose={handleDialogClose}
        messageSuccess="Customer details updated successfully!"
        messageError="Failed to update the customer details."
      />
    </Container>
  );
};
export default AddCustomer;
